import React from 'react'
import { Circle } from 'react-components'

import { ImageTransport } from '@common/transports/deprecated-home-page-transport'

interface RoundIconProps {
    image: ImageTransport
    backgroundColor: string
    radius: string
}

const RoundIcon: React.FC<RoundIconProps> = ({ image, backgroundColor, radius }) => (
    <Circle radius={radius} fillColor={backgroundColor} padding="0">
        <img src={image.url} alt={image.alt} />
    </Circle>
)

export default RoundIcon
